// import Helper from './helper';

class Fort {
  constructor(board, row, col) {
    this.b = board;
    this.r = row;
    this.c = col;
    this.pieces = [];
    this.innerSquares = [];
    this.setFortPiecesAndInnerSquares();
  }

  setFortPiecesAndInnerSquares() {
    const queue = [];
    queue.push(`${this.r}_${this.c}`);
  }

  isValid() {
    return this.pieces.length > 0;
  }

  contains(row, col) {
    if (!this.isValid()) {
      return false;
    }
    console.log(row);
    console.log(col);
    return true;
  }
}

export default Fort;
